export const numericRegex = new RegExp('^[0-9]*$')
export const twentyFourHourTimeRegex = new RegExp(
  '^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$'
)
